import { SupportedChainId } from 'constants/chains'
import { fallback, http, Transport } from 'viem'

const PROVIDER_BATCH_TIME = 200
const PROVIDER_MAX_BATCH = 25
const PROVIDER_RETRY_COUNT = 2
export const PROVIDER_POLLING_INTERVAL = 15_000

export interface BuildTransportsOptions {
  chainIds: SupportedChainId[]
  rpcUrls: Record<SupportedChainId, string[]>
  batchTime?: number
  maxBatch?: number
  retryCount?: number
}

export const buildTransports = (options: BuildTransportsOptions): Record<SupportedChainId, Transport> => {
  const {
    chainIds,
    rpcUrls,
    batchTime = PROVIDER_BATCH_TIME,
    maxBatch = PROVIDER_MAX_BATCH,
    retryCount = PROVIDER_RETRY_COUNT,
  } = options

  return chainIds.reduce((acc, chainId: SupportedChainId) => {
    const urls = rpcUrls[chainId]

    if (!urls || urls.length === 0) {
      throw new Error(`No RPC URLs provided for chainId ${chainId}`)
    }

    if (urls.length > 1) {
      const transports = urls.map((url) =>
        http(url, {
          batch: {
            wait: batchTime,
            batchSize: maxBatch,
          },
          retryCount,
        })
      )
      acc[chainId] = fallback(transports)
    } else {
      acc[chainId] = http(urls[0], {
        batch: {
          wait: batchTime,
          batchSize: maxBatch,
        },
        retryCount,
      })
    }

    return acc
  }, {} as Record<SupportedChainId, Transport>)
}
